$(document).ready(function(){
$(".linkbtn1").click(function(e){
e.preventDefault();
fbq('track', 'AddToCart');
let label = $(this).parent().parent().prev().find("span.gf_swatch.gf_selected").attr("data-value");
window.location.href=`https://checkout.thealpenforce.com/alpen-silicone-brush?quantity=1&color=${label.toLowerCase()}`;
})

$(".linkbtn2").click(function(e){
e.preventDefault();
fbq('track', 'AddToCart');
let label = $(this).parent().parent().prev().find("span.gf_swatch.gf_selected").attr("data-value");
window.location.href=`https://checkout.thealpenforce.com/alpen-silicone-brush?quantity=3&color=${label.toLowerCase()}`;
})
$(".linkbtn3").click(function(e){
e.preventDefault();
fbq('track', 'AddToCart');
let label = $(this).parent().parent().prev().find("span.gf_swatch.gf_selected").attr("data-value");
window.location.href=`https://checkout.thealpenforce.com/alpen-silicone-brush?quantity=2&color=${label.toLowerCase()}`;
})

$(".silicone-brush4-btn").click(function(e){
e.preventDefault();
let label1 = $(this).parent().parent().prev().find(".gf_swatches-option1 span.gf_swatch.gf_selected").attr("data-value");
let label2 = $(this).parent().parent().prev().find(".gf_swatches-option2 span.gf_swatch.gf_selected").attr("data-value");

if(label1.toLowerCase() == "one") {
label1 = 1;
} else if(label1.toLowerCase() == "two") {
label1 = 2; 
} else if(label1.toLowerCase() == "three") {
label1 = 3; 
} else if(label1.toLowerCase() == "four") {
label1 = 4; 
}
fbq('track', 'AddToCart');
window.location.href = `https://checkout.thealpenforce.com/alpen-silicone-brush?quantity=${label1}&color=${label2.toLowerCase()}`;
});


})